const zIndex = {
  body: 4000,
  headerFooter: 5000,
  menu: 6000,
  modal: 7000,
  loader: 9000,
  absoluteUp: 9999
};

export default zIndex;
